import type { Product } from "../types";

interface StatusPillProps {
  product: Pick<Product, "status" | "statusTone">;
}

export function StatusPill({ product }: StatusPillProps) {
  return (
    <span className={`status-pill status-pill--${product.statusTone}`}>
      {product.status}
    </span>
  );
}
